import React from 'react'
import { IconButton, Paper, useMediaQuery } from "@mui/material"
import './headerLogin.css'
import { M_Button } from 'src/M_Components'

export default function HeaderLogin({ t }) {
    const match3 = useMediaQuery('(max-height: 700px)')

    const companyButtons = [
        {
            label: "Facebook",
            link: "https://www.facebook.com/PSLPortugal/",
            src: "/icons/socialIcons/Facebook.svg"
        },
        {
            label: "Instagram",
            link: "https://www.instagram.com/pslnavegacao/",
            src: "/icons/socialIcons/Instagram.svg"
        },
        {
            label: "Linkedin",
            link: "https://www.linkedin.com/company/psl-navega%C3%A7%C3%A3o-s-a-/",
            src: "/icons/socialIcons/Linkedin.svg"
        },
        // {
        //     label: "Youtube",
        //     link: "https://www.youtube.com/@devlopsystems",
        //     src: "/icons/socialIcons/Youtube.svg"
        // },
    ]

    const onClickButton = (url) => {
        window.open(url, '_blank')
    }

    return (
        <div style={{
            position: 'absolute',
            top: '0',
            left: '0'
        }}>
            <IconButton className='iconButtonBarLogo' disableRipple={true} onClick={(e) => { }} >
                <Paper className='paperBarLogo'  >
                    {/* <img src={`/images/Logo-devlop.png`} alt="logoDevlop" className="paperStyle" /> */}
                    <div style={{ position: 'relative', height: '50px' }}>
                        <img style={{ position: 'absolute', top: '-90px' }} src={'/images/cropped_design_sem_nome_79_3_1.png'} alt={'PSL'} width={'250px'} onClick={(e) => {
                            e.target.style.transition = '10s'
                            e.target.style.transform = `translate(100vw)`
                            setTimeout(() => {
                                e.target.style.transition = '0.01s'
                                e.target.style.transform = `translate(-50vw) `
                                setTimeout(() => {
                                    e.target.style.transition = '2s'
                                    e.target.style.transform = `translate(0vw) `
                                }, 1000);
                            }, 10000);
                        }} />
                    </div>
                </Paper>
            </IconButton>
            <div style={{ display: 'flex', marginLeft: '10px' }}    >
                {companyButtons.map((el, i) => (
                    <div key={i}>
                        <M_Button
                            tooltip={el.label}
                            hoverEffect={false}
                            none
                            icon={<img
                                src={el.src}
                                alt={el.label}
                                className={el.className}
                                style={{
                                    width: '20px',
                                    filter: 'invert(9%) sepia(100%) saturate(698992%) hue-rotate(248deg) brightness(96%) contrast(144%)'
                                }}
                            />}
                            onClick={() => onClickButton(el.link)}
                        />
                    </div>
                ))}
            </div>
        </div >
    )
}